/* eslint-disable react/no-danger */
import DOMPurify from 'dompurify';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

type CustomReactMarkdownProps = {
  value: any;
  showImages?: boolean;
};

const CustomReactMarkdown = ({ value, showImages = false }: CustomReactMarkdownProps) => {
  if (showImages) {
    // Sanitize the raw HTML using DOMPurify before rendering
    const sanitizedHtml = DOMPurify.sanitize(value, { ADD_TAGS: [ 'iframe' ], ADD_ATTR: [ 'allow', 'allowfullscreen', 'frameborder', 'scrolling' ] });
    return (
      <div
        className="markdown-style"
        dangerouslySetInnerHTML={{ __html: sanitizedHtml ?? '-' }}
      />
    );
  }
  return (
    <ReactMarkdown
      className="markdown-style"
      rehypePlugins={[ rehypeRaw ]}
    >
      {value ?? '-'}
    </ReactMarkdown>
  );
};

export default CustomReactMarkdown;
